import { Component } from '@angular/core';

@Component({
  selector: 'app-home-recent',
  templateUrl: './home-recent.component.html',
  styleUrls: ['./home-recent.component.scss']
})
export class HomeRecentComponent {

}
